<div class="modal fade" id="saveCaseModal" tabindex="-1" role="dialog" aria-labelledby="saveCaseLabel">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
        <h4 class="modal-title">Saving Project</h4>
      </div>
      <div class="modal-body">
        <div class="form form-horizontal">
          <div class="form-group">
            <label for="name">Name:</label>
            <input [(ngModel)]="filename" class="form-control" name="name" id="name" type="text" />
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
        <button id="download" type="button" class="btn btn-primary" (click)="downloadCase()">Save</button>
      </div>
    </div>
  </div>
</div>
